import { forwardRef, ComponentPropsWithoutRef } from "react";
import clsx from "clsx";
import Typography from "./Typography";
import styles from "./typography.module.scss";

type ParagraphProps = {
  /** Optional extra class(es) */
  className?: string;
  /** Set to true to remove the margins */
  noMargin?: boolean;
} & ComponentPropsWithoutRef<"p">;

const Paragraph = forwardRef<HTMLElement, ParagraphProps>((props, ref) => (
  <Typography
    {...props}
    ref={ref}
    tag="p"
    className={clsx(props.className, styles.typeParagraph)}
  />
));

Paragraph.displayName = "Paragraph";

export default Paragraph;
